import auth from './auth'
import user from './user'
import navBar from './navBar'
import theme from './theme'

export default {
    auth,
    user,
    navBar,
    theme
}